import React, { useEffect, useState } from 'react';
import { MonthYear, months } from '../../../utils/MonthYear/monthYear';
import { ChevronButton } from '../Buttons/ChevronButton';

const currentYearDate = new Date().getFullYear(); // Get the current year
const currentMonthDate = new Date().getMonth() + 1; // Get the current year

interface Props {
  currentMonthYear?: MonthYear;
  setCurrentMonthYear: (_monthYear: MonthYear) => void;
  maxYear?: number;
  monthColNumber?: number;
  startingMonth?: number;
  startingYear?: number;
}

export const YearMonthSelector: React.FC<Props> = ({
  currentMonthYear,
  setCurrentMonthYear,
  monthColNumber = 3,
  maxYear = 2030,
  startingMonth = currentMonthDate,
  startingYear = currentYearDate,
}) => {
  const [yearList, setYearList] = useState([startingYear, startingYear + 1, startingYear + 2]);

  const modifyYearList = (x: number) => {
    setYearList(yearList.map((year) => year + x));
  };

  useEffect(() => {
    if (currentMonthYear?.year == startingYear && currentMonthYear.month < startingMonth) {
      setCurrentMonthYear({ year: currentMonthYear.year, month: startingMonth });
    }
  }, [currentMonthYear]);

  useEffect(() => {
    setYearList([startingYear, startingYear + 1, startingYear + 2]);
  }, [startingYear, startingMonth]);

  return (
    <div>
      <div className="flex justify-center mb-[2.5rem] space-x-[0.5rem]">
        <ChevronButton
          onButtonClick={() => modifyYearList(-1)}
          direction="left"
          disabled={startingYear == yearList[0]}
        />
        {yearList.map((year, index) => (
          <SelectedButton
            key={year + index}
            text={year.toString()}
            isSelected={currentMonthYear?.year == year}
            onClick={() => {
              setCurrentMonthYear(
                currentMonthYear
                  ? {
                      ...currentMonthYear,
                      year: year,
                    }
                  : { month: currentMonthDate, year: year },
              );
            }}
          />
        ))}
        <ChevronButton
          onButtonClick={() => modifyYearList(1)}
          direction="right"
          disabled={maxYear == yearList[yearList.length - 1]}
        />
      </div>
      <div className="flex justify-center">
        <div className={`grid grid-flow-dense grid-cols-${monthColNumber} gap-[0.5rem]`}>
          {months.map((month, index) => (
            <SelectedButton
              key={month + index}
              isDisabled={currentMonthYear ? currentMonthYear.year == startingYear && index + 1 < startingMonth : true}
              text={month}
              isSelected={currentMonthYear?.month == index + 1}
              onClick={() => {
                setCurrentMonthYear({
                  ...currentMonthYear!,
                  month: index + 1,
                });
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

interface ISelectedButtonProps {
  text: string;
  isSelected: boolean;
  isDisabled?: boolean;
  onClick: () => void;
}

const SelectedButton: React.FC<ISelectedButtonProps> = ({ isSelected, onClick, text, isDisabled = false }) => {
  return (
    <button
      disabled={isDisabled}
      className={`py-[0.35rem] px-[2rem] border-1  rounded ${isDisabled && 'opacity-50'} `.concat(
        isSelected ? 'border-pink-400 text-red shadow-md' : 'border-gray-100',
      )}
      onClick={onClick}
    >
      {text}
    </button>
  );
};
